WiseMetering.Views.ShowV2CConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/v2_charge/show',
    title: () => i18next.t('modal.title.integration_configurations.show')

    // edit: function() {
    //     new WiseMetering.Views.EditV2CConfiguration({ model: this.model });
    // }
});
